import billing from "../Assets/images/billing.jpg"
import billing2 from '../Assets/images/billing2.png'
import invoice from '../Assets/images/invoice.jpg'
import logo from '../Assets/images/logo-db.png'
import order from '../Assets/images/order.png'
import report from '../Assets/images/reporter.png'
import waiter from '../Assets/images/waiter.jpg'
import restaurant1 from '../Assets/images/restaurant.jpg'
import restaurant2 from '../Assets/images/restaurant2.jpg'
import restaurant3 from '../Assets/images/restaurant3.jpg'


const images = {
    billing,
    billing2,
    invoice,
    logo,
    order,
    report,
    waiter,
    restaurant1,
    restaurant2,
    restaurant3,
}

export default images